//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

import ReferralHero from '@/components/referral/ReferralHero.vue';

export default {
  name: 'ReferralPage',
  components: {
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    ReferralHero,
    ReferralBenefits: () => import('@/components/referral/ReferralBenefits.vue'),
    CustomizeInvitation: () => import('@/components/referral/CustomizeInvitation.vue'),
    ReferralSteps: () => import('@/components/referral/ReferralSteps.vue'),
    CardSection: () => import('@/components/core/elements/CardSection.vue'),
    ReferralStartEarningBtn: () => import('@/components/referral/ReferralStartEarningBtn.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    loggedInSubheading() {
      return this.$t(this.$wbr('affiliate_program.resources.page_subheading'), { referral_report_link: `<a href="${this.$link('/affiliate/report/referral').url()}">${this.$t('affiliate_program.affiliate_report')}</a>` });
    },
    pageTitle() {
      return this.$t('nav.affiliate_program');
    },
    pageDescription() {
      return this.$t('affiliate_program.page_heading', { percent: '30%' });
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.affiliate_program'),
          link: this.$link('/referral').fullPath(),
          active: true,
        },
      ];
    },
  },
};
